import Swal from "sweetalert2";
class LoadingService {
    static show(msg, title = "") {
        Swal.fire({
            title: title,
            text: msg,
            imageWidth: 60,
            imageHeight: 60,
            imageUrl: "/images/loading-icon.gif",
            showConfirmButton: false,
            backdrop: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });
    }
    static hide() {
        Swal.close();
    }
}
export default LoadingService;
